import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstance";
import { enum_api_uri } from "../utils/enum";

interface PostRequest {
    category: string;
    list_no: string;
    c_list_no: string;
    c_content: string;
}

interface PostResponse {
    statusCode: number;
    message: string;
    data: {
        list_no: number;
    };
}

export const usePutConsoleSuppliesComment = (): UseMutationResult<PostResponse, Error, PostRequest, unknown> => {
    return useMutation<PostResponse, Error, PostRequest>({
        mutationFn: async (data: PostRequest) => {
            const url = enum_api_uri.put_console_supplies_comment
                .replace(":category", data.category)
                .replace(":list_no", data.list_no)
                .replace(":c_list_no", data.c_list_no);

            const response = await axiosInstance.put(url, {
                c_content: data.c_content,
            });
            return response.data;
        },
        onSuccess: data => {
            return data;
        },
    });
};
